import { Route, Routes } from "react-router-dom";
import LoginPage from "../authentication/LoginPage";
import Home from "../home/Home";
import Folders from "../folders/list/Folders";
import DeviceDetails from "../devices/details/DeviceDetails";
import DeviceCards from "../devices/list/DeviceCards";

const AuthenticatedRoutes = () => (
  <Routes>
    <Route path='/' Component={Home} />
    <Route path='/f/' Component={Folders} />
    <Route path='/f/:folderId' Component={Folders} />
    <Route path='/d/' Component={DeviceCards} />
    <Route path='/d/:deviceId' Component={DeviceDetails} />
  </Routes>
);

const UnauthenticatedRoutes = () => (
    <Routes>
      <Route path='/*' Component={LoginPage} />
    </Routes>
);

export { AuthenticatedRoutes, UnauthenticatedRoutes };